import { NextSeo } from "next-seo";
import { Footer } from "@nju/feature-portal-footer";
import { WWTPage } from "@nju/feature-portal-wwt";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function Wwt() {
  return (
    <LayoutWrapper>
      <NextSeo title="sprawdź dostępność nju światłowód | nju.pl" />
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent grid="narrow" spacing="xl">
        <ClientSideOnly>
          <WWTPage variant="sales" />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
